import { Map as map } from 'immutable';
const C = require("../constants");

function AlertCancelSaleReducer(state = map(), action) {
    switch (action.type) {
        case C.SHOW_CANCEL_SALE_ALERT:
            return action.data;
        default:
            return state;
    }
}

export default AlertCancelSaleReducer;


// WEBPACK FOOTER //
// ./src/reducers/AlertCancelSaleReducer.js